import { LEGACY_SAVE_KEY, LOCAL_SAVE_KEY, SAVE_SCHEMA_VERSION, SETTINGS_KEY } from "../../game/constants/board";
import { restoreRunState } from "../../game/engine/gameState";

const safeParse = (value) => {
	try {
		return JSON.parse(value);
	} catch {
		return null;
	}
};

const normalizeLegacyRunState = (legacyState) => {
	if (!legacyState) return null;

	const towers = (legacyState.towers || []).map((tower) => ({
		id: tower.id,
		type: tower.type,
		col: tower.col,
		row: tower.row,
		level: tower.level || 0,
		cooldown: tower._cooldown || tower.cooldown || 0,
		angle: tower._angle || tower.angle || 0,
		pulse: 0,
	}));

	return restoreRunState({
		...legacyState,
		version: SAVE_SCHEMA_VERSION,
		towers,
		selectedTower: null,
		selectedPlacedId: legacyState.selectedPlaced?.id || null,
		adRewards: legacyState.adRewards || undefined,
	});
};

export const loadLocalSave = () => {
	const current = safeParse(localStorage.getItem(LOCAL_SAVE_KEY));
	if (current?.version === SAVE_SCHEMA_VERSION) return current;

	const legacy = safeParse(localStorage.getItem(LEGACY_SAVE_KEY));
	if (legacy?.state) {
		const migrated = {
			version: SAVE_SCHEMA_VERSION,
			savedAt: legacy.savedAt || Date.now(),
			profile: { displayName: "Guest Commander", email: null, migratedFrom: LEGACY_SAVE_KEY },
			progress: {},
			runState: normalizeLegacyRunState(legacy.state),
			settings: null,
		};
		saveLocalPayload(migrated);
		return migrated;
	}

	return null;
};

export const saveLocalPayload = (payload) => {
	localStorage.setItem(LOCAL_SAVE_KEY, JSON.stringify({
		...payload,
		version: SAVE_SCHEMA_VERSION,
		savedAt: Date.now(),
	}));
};

export const clearLocalSave = () => {
	localStorage.removeItem(LOCAL_SAVE_KEY);
	localStorage.removeItem(LEGACY_SAVE_KEY);
};

export const hasLocalSave = () => Boolean(localStorage.getItem(LOCAL_SAVE_KEY) || localStorage.getItem(LEGACY_SAVE_KEY));

export const loadLocalSettings = (defaults) => {
	const saved = safeParse(localStorage.getItem(SETTINGS_KEY));
	return {
		...defaults,
		...(saved || {}),
	};
};

export const saveLocalSettings = (settings) => {
	localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
};
